import { useLayoutEffect, useRef, useState } from 'react';

const VIEWPORT_PADDING = 16;

export function useDropdownFlip(isOpen) {
  const dropdownRef = useRef(null);
  const [openUpward, setOpenUpward] = useState(false);

  useLayoutEffect(() => {
    if (!isOpen) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- reset before re-measuring on next open
      setOpenUpward(false);
      return;
    }
    if (!dropdownRef.current) return;
    const rect = dropdownRef.current.getBoundingClientRect();
    setOpenUpward(window.innerHeight - rect.bottom < VIEWPORT_PADDING);
  }, [isOpen]);

  return { dropdownRef, openUpward };
}
